const FilterIcon = () => {
  return (
    <svg viewBox="0 0 18 16.481">
      <path
        d="M59.9,63.156a2.255,2.255,0,0,0-2.107,1.5H47.911a.749.749,0,1,0,0,1.5H57.79a2.231,2.231,0,0,0,4.214,0h2.388a.749.749,0,1,0,0-1.5H62A2.256,2.256,0,0,0,59.9,63.156Zm0,1.5a.735.735,0,0,1,.74.708.4.4,0,0,0,0,.085.741.741,0,0,1-1.481,0,.409.409,0,0,0,0-.085A.732.732,0,0,1,59.9,64.655ZM53.9,69.149a2.256,2.256,0,0,0-2.107,1.5H47.911a.749.749,0,1,0,0,1.5H51.8a2.231,2.231,0,0,0,4.214,0h8.381a.749.749,0,1,0,0-1.5H56.011A2.256,2.256,0,0,0,53.9,69.149Zm0,1.5a.734.734,0,0,1,.74.705.437.437,0,0,0,0,.088.741.741,0,0,1-1.481,0,.459.459,0,0,0,0-.088A.732.732,0,0,1,53.9,70.648Zm3,4.495a2.256,2.256,0,0,0-2.107,1.5H47.911a.749.749,0,1,0,0,1.5h6.883a2.231,2.231,0,0,0,4.214,0h5.385a.749.749,0,1,0,0-1.5H59.007A2.255,2.255,0,0,0,56.9,75.143Zm0,1.5a.734.734,0,0,1,.74.705.466.466,0,0,0,0,.088.741.741,0,0,1-1.481,0,.43.43,0,0,0,0-.088A.732.732,0,0,1,56.9,76.641Z"
        transform="translate(-47.151 -63.156)"
        fill="#075da9"
      />
    </svg>
  );
};

export default FilterIcon;
